__turbopack_context__.v({
  "alerts": "SignUpForm-module-scss-module__8ICtyq__alerts",
  "checkbox": "SignUpForm-module-scss-module__8ICtyq__checkbox",
  "checkmark": "SignUpForm-module-scss-module__8ICtyq__checkmark",
  "eyebrow": "SignUpForm-module-scss-module__8ICtyq__eyebrow",
  "header": "SignUpForm-module-scss-module__8ICtyq__header",
  "headline": "SignUpForm-module-scss-module__8ICtyq__headline",
  "isFocus": "SignUpForm-module-scss-module__8ICtyq__isFocus",
  "label": "SignUpForm-module-scss-module__8ICtyq__label",
  "optIn": "SignUpForm-module-scss-module__8ICtyq__optIn",
  "optIns": "SignUpForm-module-scss-module__8ICtyq__optIns",
  "optInsAndSubmit": "SignUpForm-module-scss-module__8ICtyq__optInsAndSubmit",
  "root": "SignUpForm-module-scss-module__8ICtyq__root",
  "rules": "SignUpForm-module-scss-module__8ICtyq__rules",
  "submit": "SignUpForm-module-scss-module__8ICtyq__submit",
  "submitSpinner": "SignUpForm-module-scss-module__8ICtyq__submitSpinner",
  "submitWrapper": "SignUpForm-module-scss-module__8ICtyq__submitWrapper",
});
